// Add your custom JS here.
(function ($) {
    // Fade in effects
    AOS.init();

    // Smooth anchor scrolling
    var scroll = new SmoothScroll('a[href*="#"]', {
        speed: 300,
    });

    new PureCounter({
        selector: ".amount",
        separator: true,
        formater: "nl-NL",
        decimals: 0,
    });

    var lastScrollTop = 0;
    $(window).scroll(function (event) {
        var st = $(this).scrollTop();
        if (st > lastScrollTop) {
            $("#wrapper-navbar").addClass("hide");
        } else {
            $("#wrapper-navbar").removeClass("hide");
        }
        lastScrollTop = st;
    });

    //check if header is at top of page
    $(document).scroll(function () {
        if ($(this).scrollTop() > 100) {
            $("#wrapper-navbar").addClass("off-top");
        }
        if ($(this).scrollTop() < 100) {
            $("#wrapper-navbar").removeClass("off-top");
        }
    });

    // Swiper example
    // var swiper = new Swiper(".carouselname-swiper", {
    //     slidesPerView: "auto",
    //     center: true,
    //     loop: false,
    //     pagination: {
    //         el: ".carouselname-pagination",
    //         clickable: true,
    //         renderBullet: function (index, className) {
    //             return '<span class="' + className + '"></span>';
    //         },
    //     },
    //     navigation: {
    //         nextEl: ".carouselname-next",
    //         prevEl: ".carouselname-prev",
    //     },
    //     breakpoints: {
    //         768: {
    //           spaceBetween: 500,
    //         },
    //         1024: {
    //           spaceBetween: 500,
    //         },
    //       },
    // });

    // When the user scrolls the page, execute myFunction
    window.onscroll = function () {
        myFunction();
    };

    function myFunction() {
        var winScroll =
            document.body.scrollTop || document.documentElement.scrollTop;
        var height =
            document.documentElement.scrollHeight -
            document.documentElement.clientHeight;
        var scrolled = (winScroll / height) * 100;
        document.getElementById("bar").style.width = scrolled + "%";
    }

    $(".hamburger").on("click", function () {
        $(this).toggleClass("active");

        $(".menu-wrapper-mobile").slideToggle();
        $(".menu-wrapper-mobile").toggleClass("active");
    });

    $(".menu-wrapper-mobile li a").on('click', function() {
        $(".hamburger").toggleClass("active");
        $(".menu-wrapper-mobile").slideToggle();
        $(".menu-wrapper-mobile").toggleClass("active");
    })
})(jQuery);
